import i18next from "i18next";
import API from "../../Api/Api.js";
import { otherLanguage, productUrlRewrite } from "../../utils/utils.js";
import { closeModal } from "./confirmationModal.js";
import { handleError, handleInfo } from "./notifications.js";
import qs from "qs";
import {
  createCardsDuplicate,
  getCards,
  PRODUCT_QUERY,
} from "../../utils/products.js";
const token = localStorage.getItem("token");

export const getAllProducts =
  (filter, withLoading = true) =>
  async (dispatch) => {
    API.defaults.headers.common["Authorization"] = token;

    const query = qs.stringify(
      {
        filters: {
          name: {
            $containsi: filter,
          },
        },
        populate: {
          localizations: {
            populate: "*",
          },

          image: {
            populate: {
              url: "*",
            },
          },
          image2: {
            populate: {
              url: "*",
            },
          },
        },
        sort: ["createdAt:desc"],
      },

      {
        encodeValuesOnly: true,
      },
    );
    API.defaults.params = { locale: i18next.language };
    if (withLoading) {
      dispatch({ type: "PRODUCTS_LOADING" });
    }
    try {
      let { data } = await API.get("/api/products?" + query);
      dispatch({ type: "FETCH_PRODUCTS", payload: data.data });
    } catch (error) {
      dispatch(handleError("erreur réseau", 1));
      console.log(error);
    }
  };

export const deleteProduct = (id) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  dispatch({ type: "PRODUCTS_LOADING" });
  try {
    await API.delete(`api/products/${id}`);
    dispatch(getAllProducts());
    dispatch(handleInfo("Produit supprimé", 1));
    dispatch(closeModal());
  } catch (error) {
    dispatch(handleError("Erreur lors de la suppression du produit", 1));
    console.log(error);
  }
};

export const getProductItem = (id, noLoading) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  const query = qs.stringify(
    {
      filters: { id: { $eq: id } },
      populate: {
        localizations: {
          populate: "*",
        },
        banner: {
          populate: "*",
        },
        image: {
          populate: {
            url: "*",
          },
        },
        image2: {
          populate: {
            url: "*",
          },
        },
        ficheTechnique: {
          populate: {
            url: "*",
          },
        },
        pointfort: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        realisation: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        pointreassurance: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        versionImages: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        jetList: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        relatedProducts: {
          populate: "attributes",
        },
        colors: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        cuveColors: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        seo: {
          populate: "ogimage",
        },
      },
    },
    { encodeValuesOnly: true },
  );
  API.defaults.params = { locale: i18next.language };
  if (!noLoading) {
    dispatch({ type: "PRODUCTS_LOADING" });
  }

  try {
    let { data } = await API.get("/api/products?" + query);

    dispatch({ type: "FETCH_PRODUCT_ITEM", payload: data.data[0] });
    dispatch({ type: "LIST_DONE_LOADING" });
  } catch (error) {
    dispatch(handleError("erreur réseau", 1));
    console.log(error);
  }
};

const createList = async (defaultObject, name, resolution) => {
  let cardFR = await API.post("/api/cards", {
    data: defaultObject,
    params: { locale: i18next.language },
  });
  let cardEN = await API.post(
    `/api/cards/${cardFR.data.data.id}/localizations`,
    { locale: otherLanguage(i18next.language), ...defaultObject },
  );

  let defaultListFR = {
    name: `Liste ${name} produit`,
    resolution: resolution,

    cards: [cardFR.data.data.id],
  };

  let defaultListEN = {
    name: `Liste ${name} produit`,
    resolution: resolution,
    cards: [cardEN.data.id],
  };

  let listFR = await API.post("/api/lists", {
    data: defaultListFR,
    params: { locale: i18next.language },
  });
  let listEN = await API.post(
    `/api/lists/${listFR.data.data.id}/localizations`,
    { locale: otherLanguage(i18next.language), ...defaultListEN },
  );

  return { listFR, listEN };
};

const createListWithMultipleCards = async (
  defaultObjects,
  name,
  resolution,
) => {
  let cardIdsFR = [];
  let cardIdsEN = [];

  // Create all cards
  for (const cardObject of defaultObjects) {
    let cardFR = await API.post("/api/cards", {
      data: cardObject,
      params: { locale: "fr" },
    });
    let cardEN = await API.post(
      `/api/cards/${cardFR.data.data.id}/localizations`,
      { locale: "en", ...cardObject },
    );

    cardIdsFR.push(cardFR.data.data.id);
    cardIdsEN.push(cardEN.data.id);
  }

  let defaultListFR = {
    name: `Liste ${name} produit`,
    resolution: resolution,
    cards: cardIdsFR,
  };

  let defaultListEN = {
    name: `Liste ${name} produit`,
    resolution: resolution,
    cards: cardIdsEN,
  };

  let listFR = await API.post("/api/lists", {
    data: defaultListFR,
    params: { locale: "fr" },
  });
  let listEN = await API.post(
    `/api/lists/${listFR.data.data.id}/localizations`,
    { locale: "en", ...defaultListEN },
  );

  return { listFR, listEN };
};

export const addProduct = () => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  API.defaults.params = {};
  let defaultImage = null;

  dispatch({ type: "PRODUCTS_LOADING" });
  try {
    let image = await API.get("/api/upload/files");
    defaultImage = image.data[0].id;
  } catch (error) {
    dispatch(handleError("Erreur reseau", 1));

    console.log(error);
  }

  try {
    if (!defaultImage) {
      return dispatch(
        handleError("Importer au moin une image pour procéder", 1),
      );
    }
    let pointfort = {
      name: `carte point fort produit par défault`,
      title: `Titre point fort par default`,
      description: `Description point fort par default`,
      content: `Contenu point fort par default`,
      image: defaultImage,
      image2: defaultImage,
    };

    let pointReassurance = {
      name: `carte point de réassurance produit par défault`,
      title: `Titre point de réassurance par default`,
      description: `Description point de réassurance par default`,
      content: `Contenu point de réassurance par default`,
      image: defaultImage,
      image2: defaultImage,
    };

    let realisation = {
      name: `carte nos réalisations produit par défault`,
      image: defaultImage,
    };

    let histoireTherapy = {
      name: `carte histoire de thérapie produit par défault`,
      title: "titre histoire de thérapie",
      description: `Description histoire de thérapie par default`,
      image: defaultImage,
    };

    let versionImages = {
      name: `carte Liste d'images`,
      image: defaultImage,
    };

    let listPointFort = await createList(pointfort, "point fort", "icone");

    let listPointReassurance = await createList(
      pointReassurance,
      "point de réassurance",
      "icone",
    );

    let nosRealisations = await createList(
      realisation,
      "nos réalisations",
      "carré",
    );

    let jetList = await createList(
      histoireTherapy,
      "histoire de thérapie",
      "carré",
    );

    let imagesProduits = await createList(
      versionImages,
      "autre images",
      "carré",
    );

    // const defaultjetSection = {
    //   name: "Section histoire de thérapie produit ",
    //   image: [defaultImage],
    //   resolution: "Video",
    //   list: jetList.listFR.data.data.id,
    // };
    // const defaultjetSectionEng = {
    //   name: "Section histoire de thérapie produit",
    //   image: [defaultImage],
    //   resolution: "Video",
    //   list: jetList.listEN.data.id,
    // };

    // let jetSection = await API.post("/api/sections", {
    //   data: defaultjetSection,
    //   params: { locale: i18next.language },
    // });
    // const jetSectionEn = await API.post(
    //   `/api/sections/${jetSection.data.data.id}/localizations`,
    //   { locale: otherLanguage(i18next.language), ...defaultjetSectionEng }
    // );

    let couleurHabillage = {
      name: "Couleur Produit",
      image: defaultImage,
    };

    let listCouleurHabillage = await createList(
      couleurHabillage,
      "couleur habillage",
    );

    let couleurCuve = {
      name: "Couleur Produit",
      image: defaultImage,
    };

    let listCouleurCuve = await createList(couleurCuve, "couleur cuve");

    let defaultSEOFR = {
      title: "titre SEO produit par defaut",
      description: "SEO description produit par defaut",
      ogimage: defaultImage,
    };
    let defaultSEOEN = {
      title: "titre SEO produit par defaut (en)",
      description: "SEO description produit par defaut (en)",
      ogimage: defaultImage,
    };

    let SEOfr = await API.post("/api/seos", {
      data: defaultSEOFR,
      params: { locale: i18next.language },
    });
    const SEOen = await API.post(
      `/api/seos/${SEOfr.data.data.id}/localizations`,
      { locale: otherLanguage(i18next.language), ...defaultSEOEN },
    );

    const defaultBanner = {
      name: "Banniére produit ",
      title: "banniere par default",
      subtitle: "soustitre par default",
      image: [defaultImage],
    };
    const defaultBannerEng = {
      name: "Banniére produit",
      title: "banniere par default (en)",
      subtitle: "soustitre par default (en)",
      image: [defaultImage],
    };

    let bannerfr = await API.post("/api/sections", {
      data: defaultBanner,
      params: { locale: i18next.language },
    });
    const banneren = await API.post(
      `/api/sections/${bannerfr.data.data.id}/localizations`,
      { locale: otherLanguage(i18next.language), ...defaultBannerEng },
    );

    let defaultProductFr = {
      name: "Produit par défaut",
      type: 0,
      collection: 0,
      places: 1,
      onstock: 0,
      price: "10 000",
      ficheTechnique: 444,
      banner: bannerfr.data.data.id,
      jetList: jetList.listFR.data.data.id,
      pointfort: listPointFort.listFR.data.data.id,
      colors: listCouleurHabillage.listFR.data.data.id,
      cuveColors: listCouleurCuve.listFR.data.data.id,
      pointreassurance: listPointReassurance.listFR.data.data.id,
      realisation: nosRealisations.listFR.data.data.id,
      versionImages: imagesProduits.listFR.data.data.id,
      image: defaultImage,
      image2: defaultImage,
      seo: SEOfr.data.data.id,
    };

    let defaultProductEN = {
      name: "Produit par défaut (en)",
      type: 0,
      collection: 0,
      places: 1,
      onstock: 0,
      price: "10 000",
      ficheTechnique: 444,
      banner: banneren.data.id,
      jetList: jetList.listEN.data.id,
      pointfort: listPointFort.listEN.data.id,
      colors: listCouleurHabillage.listEN.data.id,
      cuveColors: listCouleurCuve.listEN.data.id,
      pointreassurance: listPointReassurance.listEN.data.id,
      realisation: nosRealisations.listEN.data.id,
      versionImages: imagesProduits.listEN.data.id,
      image: defaultImage,
      image2: defaultImage,
      seo: SEOen.data.id,
    };

    const productFr = await API.post("/api/products", {
      data: defaultProductFr,
      params: { locale: i18next.language },
    });
    const productEn = await API.post(
      `/api/products/${productFr.data.data.id}/localizations`,
      { locale: otherLanguage(i18next.language), ...defaultProductEN },
    );

    await API.put(`/api/products/${productFr.data.data.id}`, {
      data: {
        path: productUrlRewrite(
          productFr.data.data.id,
          productFr.data.data.attributes.name,
        ),
      },
    });
    await API.put(`/api/products/${productEn.data.id}`, {
      data: {
        path: productUrlRewrite(productEn.data.id, productEn.data.name),
      },
    });

    dispatch(
      handleInfo("Produit par défaut Ajouté (Vous pouvez le modifier) ", 1),
    );
    dispatch(getAllProducts());
  } catch (error) {
    dispatch(handleError("erreur réseau", 1));
    console.log(error);
  }
};

export const updateProduct = (id, product) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  dispatch({ type: "PRODUCTS_LOADING" });
  try {
    await API.put(`/api/products/${id}`, { data: product });
    dispatch(handleInfo("Produit Modifié", 1));
    dispatch(getProductItem(id));
  } catch (error) {
    dispatch(handleError("erreur réseau", 1));
    console.log(error);
  }
};

export const showOrHideProduct = (ids, hide) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  try {
    for (const id of ids) {
      if (id !== null && id !== undefined) {
        await API.put(`api/products/${id}`, { data: { hide: hide } });
      }
    }

    dispatch(getAllProducts({}, false));
    dispatch(closeModal());
    dispatch(handleInfo(hide ? "Produit caché" : "Produit affiché", 1));
  } catch (error) {
    dispatch(handleError("Erreur lors de la publication du produit", 1));
    console.log(error);
  }
};

export const duplicateNoFrProduct = (id) => async (dispatch, getState) => {
  API.defaults.headers.common["Authorization"] = token;
  dispatch({ type: "PRODUCTS_LOADING" });
  try {
    await dispatch(getProductItem(id));
    const { productItem } = getState().productsReducer;
    dispatch({ type: "PRODUCTS_LOADING" });

    if (productItem) {
      API.defaults.params = {};
      let defaultImage = null;
      try {
        let image = await API.get("/api/upload/files");
        defaultImage = image.data[0].id;
      } catch (error) {
        dispatch(handleError("Erreur reseau", 1));
        console.log(error);
      }

      if (!defaultImage) {
        return dispatch(
          handleError("Importer au moin une image pour procéder", 1),
        );
      }

      // Get original cards or create defaults
      const originalPointFortCards =
        productItem?.attributes?.pointfort?.data?.attributes?.cards?.data || [];
      const originalPointReassuranceCards =
        productItem?.attributes?.pointreassurance?.data?.attributes?.cards
          ?.data || [];
      const originalRealisationCards =
        productItem?.attributes?.realisation?.data?.attributes?.cards?.data ||
        [];
      const originalJetListCards =
        productItem?.attributes?.jetList?.data?.attributes?.cards?.data || [];
      const originalVersionImagesCards =
        productItem?.attributes?.versionImages?.data?.attributes?.cards?.data ||
        [];
      const originalColorHabillageCards =
        productItem?.attributes?.colors?.data?.attributes?.cards?.data || [];
      const originalColorCuveCards =
        productItem?.attributes?.cuveColors?.data?.attributes?.cards?.data ||
        [];

      const defaultPointFort = {
        title: "Titre point fort par default",
        description: "Description point fort par default",
        content: "Contenu point fort par default",
      };

      const defaultPointReassurance = {
        title: "Titre point de réassurance par default",
        description: "Description point de réassurance par default",
        content: "Contenu point de réassurance par default",
      };

      const defaultRealisation = {
        title: "Titre nos réalisation par default",
        description: "Description nos réalisation par default",
        content: "Contenu nos réalisation par default",
      };
      const defaultJetList = {
        title: "titre histoire de thérapie",
        description: "Description histoire de thérapie par default",
        content: "Contenu histoire de thérapie par default",
      };

      // Generate all cards
      const pointfortCards = createCardsDuplicate(
        originalPointFortCards,
        "point fort",
        defaultPointFort,
      );
      const pointReassuranceCards = createCardsDuplicate(
        originalPointReassuranceCards,
        "point de réassurance",
        defaultPointReassurance,
      );
      const realisationCards = createCardsDuplicate(
        originalRealisationCards,
        "nos réalisations",
        defaultRealisation,
      );
      const jetListCards = createCardsDuplicate(
        originalJetListCards,
        "histoire de thérapie",
        defaultJetList,
      );
      const colorHabillageCards = createCardsDuplicate(
        originalColorHabillageCards,
        "couleur habillage",
        {},
        defaultImage,
      );
      const colorCuveCards = createCardsDuplicate(
        originalColorCuveCards,
        "couleur cuve",
        {},
        defaultImage,
      );
      const versionImagesCards = createCardsDuplicate(
        originalVersionImagesCards,
        "Liste d'images",
        {},
        defaultImage,
        ["name", "image", "image2"],
      );

      // Create new lists using all cards from each array (only if cards exist)
      let listPointFort =
        pointfortCards.length > 0
          ? await createListWithMultipleCards(
              pointfortCards,
              productItem?.attributes?.pointfort?.data?.attributes?.name ||
                "point fort",
              productItem?.attributes?.pointfort?.data?.attributes
                ?.resolution || "icone",
            )
          : null;
      let listPointReassurance =
        pointReassuranceCards.length > 0
          ? await createListWithMultipleCards(
              pointReassuranceCards,
              productItem?.attributes?.pointreassurance?.data?.attributes
                ?.name || "point de réassurance",
              productItem?.attributes?.pointreassurance?.data?.attributes
                ?.resolution || "icone",
            )
          : null;
      let nosRealisations =
        realisationCards.length > 0
          ? await createListWithMultipleCards(
              realisationCards,
              productItem?.attributes?.realisation?.data?.attributes?.name ||
                "nos réalisations",
              productItem?.attributes?.realisation?.data?.attributes
                ?.resolution || "carré",
            )
          : null;
      let jetList =
        jetListCards.length > 0
          ? await createListWithMultipleCards(
              jetListCards,
              productItem?.attributes?.jetList?.data?.attributes?.name ||
                "histoire de thérapie",
              productItem?.attributes?.jetList?.data?.attributes?.resolution ||
                "carré",
            )
          : null;
      let imagesProduits =
        versionImagesCards.length > 0
          ? await createListWithMultipleCards(
              versionImagesCards,
              productItem?.attributes?.versionImages?.data?.attributes?.name ||
                "autre images",
              productItem?.attributes?.versionImages?.data?.attributes
                ?.resolution || "carré",
            )
          : null;

      let listCouleurHabillage =
        colorHabillageCards.length > 0
          ? await createListWithMultipleCards(
              colorHabillageCards,
              productItem?.attributes?.colors?.data?.attributes?.name ||
                "Couleur Habillage",
              productItem?.attributes?.colors?.data?.attributes?.resolution ||
                "carré",
            )
          : await createList(
              { name: "Couleur Produit dupliquée", image: defaultImage },
              "couleur habillage",
            );

      let listCouleurCuve =
        colorCuveCards.length > 0
          ? await createListWithMultipleCards(
              colorCuveCards,
              productItem?.attributes?.cuveColors?.data?.attributes?.name ||
                "Couleur Habillage",
              productItem?.attributes?.cuveColors?.data?.attributes
                ?.resolution || "carré",
            )
          : await createList(
              { name: "Couleur Produit dupliquée", image: defaultImage },
              "couleur cuve",
            );

      // ENGLISSHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH
      // Find the English localization
      const englishProductWithLocal =
        productItem?.attributes?.localizations?.data?.find(
          (loc) => loc.attributes.locale === "en",
        );

      let englishProduct;
      if (englishProductWithLocal?.id) {
        const englishProductResponse = await API.get(
          `/api/products/${englishProductWithLocal.id}?${PRODUCT_QUERY}`,
        );
        englishProduct = englishProductResponse.data.data;
      }

      const originalPointFortCardsEN = getCards(
        "pointfort",
        englishProduct,
        productItem,
      );
      const originalPointReassuranceCardsEN = getCards(
        "pointreassurance",
        englishProduct,
        productItem,
      );
      const originalRealisationCardsEN = getCards(
        "realisation",
        englishProduct,
        productItem,
      );
      const originalJetListCardsEN = getCards(
        "jetList",
        englishProduct,
        productItem,
      );
      const originalVersionImagesCardsEN = getCards(
        "versionImages",
        englishProduct,
        productItem,
      );
      const originalColorHabillageCardsEN = getCards(
        "colors",
        englishProduct,
        productItem,
      );
      const originalColorCuveCardsEN = getCards(
        "cuveColors",
        englishProduct,
        productItem,
      );

      console.log("Creating English cards...");
      const pointfortCardsEN = createCardsDuplicate(
        originalPointFortCardsEN,
        "point fort",
        {
          title: "Titre point fort par default",
          description: "Description point fort par default",
          content: "Contenu point fort par default",
        },
        defaultImage,
      );

      const pointReassuranceCardsEN = createCardsDuplicate(
        originalPointReassuranceCardsEN,
        "point de réassurance",
        {
          title: "Titre point de réassurance par default",
          description: "Description point de réassurance par default",
          content: "Contenu point de réassurance par default",
        },
        defaultImage,
      );
      const realisationCardsEN = createCardsDuplicate(
        originalRealisationCardsEN,
        "nos réalisations",
        {
          title: "Titre nos réalisation par default",
          description: "Description nos réalisation par default",
          content: "Contenu nos réalisation par default",
        },
        defaultImage,
      );

      // Create jetList cards
      const jetListCardsEN = createCardsDuplicate(
        originalJetListCardsEN,
        "histoire de thérapie",
        {
          title: "titre histoire de thérapie",
          description: "Description histoire de thérapie par default",
          content: "Contenu histoire de thérapie par default",
        },
        defaultImage,
      );
      // Create versionImages cards
      const versionImagesCardsEN = createCardsDuplicate(
        originalVersionImagesCardsEN,
        "Liste d'images",
        {},
        defaultImage,
        ["name", "image", "image2"], // only these fields
      );

      // Create color cards
      const colorHabillageCardsEN = createCardsDuplicate(
        originalColorHabillageCardsEN,
        "couleur habillage",
        {},
        defaultImage,
      );

      const colorCuveCardsEN = createCardsDuplicate(
        originalColorCuveCardsEN,
        "couleur cuve",
        {},
        defaultImage,
      );

      // Create new lists using all cards from each array (only if cards exist)
      let listPointFortEN =
        pointfortCardsEN.length > 0
          ? await createListWithMultipleCards(
              pointfortCardsEN,
              englishProduct?.attributes?.pointfort?.data?.attributes?.name ||
                "point fort",
              englishProduct?.attributes?.pointfort?.data?.attributes
                ?.resolution || "icone",
            )
          : null;

      let listPointReassuranceEN =
        pointReassuranceCardsEN.length > 0
          ? await createListWithMultipleCards(
              pointReassuranceCardsEN,
              englishProduct?.attributes?.pointreassurance?.data?.attributes
                ?.name || "point de réassurance",
              englishProduct?.attributes?.pointreassurance?.data?.attributes
                ?.resolution || "icone",
            )
          : null;
      let nosRealisationsEN =
        realisationCardsEN.length > 0
          ? await createListWithMultipleCards(
              realisationCardsEN,
              englishProduct?.attributes?.realisation?.data?.attributes?.name ||
                "nos réalisations",
              englishProduct?.attributes?.realisation?.data?.attributes
                ?.resolution || "carré",
            )
          : null;
      let jetListEN =
        jetListCardsEN.length > 0
          ? await createListWithMultipleCards(
              jetListCardsEN,
              englishProduct?.attributes?.jetList?.data?.attributes?.name ||
                "histoire de thérapie",
              englishProduct?.attributes?.jetList?.data?.attributes
                ?.resolution || "carré",
            )
          : null;
      let imagesProduitsEN =
        versionImagesCardsEN.length > 0
          ? await createListWithMultipleCards(
              versionImagesCardsEN,
              englishProduct?.attributes?.versionImages?.data?.attributes
                ?.name || "autre images",
              englishProduct?.attributes?.versionImages?.data?.attributes
                ?.resolution || "carré",
            )
          : null;

      let listCouleurHabillageEN =
        colorHabillageCardsEN.length > 0
          ? await createListWithMultipleCards(
              colorHabillageCardsEN,
              englishProduct?.attributes?.colors?.data?.attributes?.name ||
                "Couleur Habillage",
              englishProduct?.attributes?.colors?.data?.attributes
                ?.resolution || "carré",
            )
          : await createList(
              { name: "Couleur Produit dupliquée", image: defaultImage },
              "couleur habillage",
            );

      let listCouleurCuveEN =
        colorCuveCardsEN.length > 0
          ? await createListWithMultipleCards(
              colorCuveCardsEN,
              englishProduct?.attributes?.cuveColors?.data?.attributes?.name ||
                "Couleur Habillage",
              englishProduct?.attributes?.cuveColors?.data?.attributes
                ?.resolution || "carré",
            )
          : await createList(
              { name: "Couleur Produit dupliquée", image: defaultImage },
              "couleur cuve",
            );

      // SEO
      let defaultSEOFR = {
        title:
          productItem?.attributes?.seo?.data?.attributes?.title ||
          "titre SEO produit par defaut",
        description:
          productItem?.attributes?.seo?.data?.attributes?.description ||
          "SEO description produit par defaut",
        ogimage:
          productItem?.attributes?.seo?.data?.attributes?.ogimage?.data?.id,
        url: productItem?.attributes?.seo?.data?.attributes?.url,
      };
      let defaultSEOEN = {
        title:
          englishProduct?.attributes?.seo?.data?.attributes?.title ||
          productItem?.attributes?.seo?.data?.attributes?.title ||
          "titre SEO produit par defaut (en)",
        description:
          englishProduct?.attributes?.seo?.data?.attributes?.description ||
          productItem?.attributes?.seo?.data?.attributes?.description ||
          "SEO description produit par defaut (en)",
        ogimage:
          englishProduct?.attributes?.seo?.data?.attributes?.ogimage?.data
            ?.id ||
          productItem?.attributes?.seo?.data?.attributes?.ogimage?.data?.id,
        url:
          englishProduct?.attributes?.seo?.data?.attributes?.url ||
          productItem?.attributes?.seo?.data?.attributes?.url,
      };

      let SEOfr = await API.post("/api/seos", {
        data: defaultSEOFR,
        params: { locale: i18next.language },
      });

      const SEOen = await API.post(
        `/api/seos/${SEOfr.data.data.id}/localizations`,
        { locale: otherLanguage(i18next.language), ...defaultSEOEN },
      );

      // Create banner
      const defaultBanner = {
        name: "Banniére produit dupliqué",
        title:
          productItem?.attributes?.banner?.data?.attributes?.title ||
          "banniere par default",
        subtitle:
          productItem?.attributes?.banner?.data?.attributes?.subtitle ||
          "soustitre par default",
        description:
          productItem?.attributes?.banner?.data?.attributes?.description,
        content: productItem?.attributes?.banner?.data?.attributes?.content,
        buttonText:
          productItem?.attributes?.banner?.data?.attributes?.buttonText,
        buttonUrl: productItem?.attributes?.banner?.data?.attributes?.buttonUrl,
        image:
          productItem?.attributes?.banner?.data?.attributes?.image?.data?.id,
        image2:
          productItem?.attributes?.banner?.data?.attributes?.image2?.data?.id,
        carousel:
          productItem?.attributes?.banner?.data?.attributes?.carousel?.data?.id,
        regularTitle:
          productItem?.attributes?.banner?.data?.attributes?.regularTitle,
        decoratedTitle:
          productItem?.attributes?.banner?.data?.attributes?.decoratedTitle,
        limitedCarousel:
          productItem?.attributes?.banner?.data?.attributes?.limitedCarousel,
        showButton:
          productItem?.attributes?.banner?.data?.attributes?.showButton,
        resolution:
          productItem?.attributes?.banner?.data?.attributes?.resolution,
        imageMobile2:
          productItem?.attributes?.banner?.data?.attributes?.imageMobile2?.data
            ?.id,
        imageMobile:
          productItem?.attributes?.banner?.data?.attributes?.imageMobile?.data
            ?.id,
        resolutionMobile:
          productItem?.attributes?.banner?.data?.attributes?.resolutionMobile,
      };
      const defaultBannerEng = {
        name: "Banniére produit dupliqué",
        title:
          englishProduct?.attributes?.banner?.data?.attributes?.title ||
          productItem?.attributes?.banner?.data?.attributes?.title ||
          "banniere par default (en)",
        subtitle:
          englishProduct?.attributes?.banner?.data?.attributes?.subtitle ||
          productItem?.attributes?.banner?.data?.attributes?.subtitle ||
          "soustitre par default (en)",
        description:
          englishProduct?.attributes?.banner?.data?.attributes?.description ||
          productItem?.attributes?.banner?.data?.attributes?.description,
        content:
          englishProduct?.attributes?.banner?.data?.attributes?.content ||
          productItem?.attributes?.banner?.data?.attributes?.content,
        buttonText:
          englishProduct?.attributes?.banner?.data?.attributes?.buttonText ||
          productItem?.attributes?.banner?.data?.attributes?.buttonText,
        buttonUrl:
          englishProduct?.attributes?.banner?.data?.attributes?.buttonUrl ||
          productItem?.attributes?.banner?.data?.attributes?.buttonUrl,
        image:
          englishProduct?.attributes?.banner?.data?.attributes?.image?.data
            ?.id ||
          productItem?.attributes?.banner?.data?.attributes?.image?.data?.id,
        image2:
          englishProduct?.attributes?.banner?.data?.attributes?.image2?.data
            ?.id ||
          productItem?.attributes?.banner?.data?.attributes?.image2?.data?.id,
        carousel:
          englishProduct?.attributes?.banner?.data?.attributes?.carousel?.data
            ?.id ||
          productItem?.attributes?.banner?.data?.attributes?.carousel?.data?.id,
        regularTitle:
          englishProduct?.attributes?.banner?.data?.attributes?.regularTitle ||
          productItem?.attributes?.banner?.data?.attributes?.regularTitle,
        decoratedTitle:
          englishProduct?.attributes?.banner?.data?.attributes
            ?.decoratedTitle ||
          productItem?.attributes?.banner?.data?.attributes?.decoratedTitle,
        limitedCarousel:
          englishProduct?.attributes?.banner?.data?.attributes
            ?.limitedCarousel ||
          productItem?.attributes?.banner?.data?.attributes?.limitedCarousel,
        showButton:
          englishProduct?.attributes?.banner?.data?.attributes?.showButton ||
          productItem?.attributes?.banner?.data?.attributes?.showButton,
        resolution:
          englishProduct?.attributes?.banner?.data?.attributes?.resolution ||
          productItem?.attributes?.banner?.data?.attributes?.resolution,
        imageMobile2:
          englishProduct?.attributes?.banner?.data?.attributes?.imageMobile2
            ?.data?.id ||
          productItem?.attributes?.banner?.data?.attributes?.imageMobile2?.data
            ?.id,
        imageMobile:
          englishProduct?.attributes?.banner?.data?.attributes?.imageMobile
            ?.data?.id ||
          productItem?.attributes?.banner?.data?.attributes?.imageMobile?.data
            ?.id,
        resolutionMobile:
          englishProduct?.attributes?.banner?.data?.attributes
            ?.resolutionMobile ||
          productItem?.attributes?.banner?.data?.attributes?.resolutionMobile,
      };

      let bannerfr = await API.post("/api/sections", {
        data: { ...defaultBanner, locale: i18next.language },
      });
      const banneren = await API.post(
        `/api/sections/${bannerfr.data.data.id}/localizations`,
        { locale: otherLanguage(i18next.language), ...defaultBannerEng },
      );

      // Create duplicated product with original data but new relations
      let defaultProductFr = {
        name: `${productItem?.attributes?.name} (copie)`,
        titre4: `${productItem?.attributes?.titre4} (copie)`,
        soustitre3: productItem?.attributes?.soustitre3,
        type: productItem?.attributes?.type || 0,
        collection: productItem?.attributes?.collection || 0,
        places: productItem?.attributes?.places || 1,
        onstock: productItem?.attributes?.onstock || 0,
        price: productItem?.attributes?.price || "10 000",
        ficheTechnique:
          productItem?.attributes?.ficheTechnique?.data?.id || 444,
        banner: bannerfr.data.data.id,
        jetList: jetList?.listFR?.data?.data?.id || null,
        pointfort: listPointFort?.listFR?.data?.data?.id || null,
        colors: listCouleurHabillage.listFR.data.data.id,
        cuveColors: listCouleurCuve.listFR.data.data.id,
        pointreassurance: listPointReassurance?.listFR?.data?.data?.id || null,
        realisation: nosRealisations?.listFR?.data?.data?.id || null,
        versionImages: imagesProduits?.listFR?.data?.data?.id || null,
        image: productItem?.attributes?.image?.data?.id || defaultImage,
        image2: productItem?.attributes?.image2?.data?.id || defaultImage,
        seo: SEOfr.data.data.id,
        subtitle: productItem?.attributes?.subtitle,
        description: productItem?.attributes?.description,
        caracrteristique_longueur:
          productItem?.attributes?.caracrteristique_longueur,
        caracrteristique_largeur:
          productItem?.attributes?.caracrteristique_largeur,
        caracrteristique_hauteur:
          productItem?.attributes?.caracrteristique_hauteur,
        caracrteristique_capacite:
          productItem?.attributes?.caracrteristique_capacite,
        caracrteristique_places_allonges:
          productItem?.attributes?.caracrteristique_places_allonges,
        caracrteristique_places_assise:
          productItem?.attributes?.caracrteristique_places_assise,
        caracrteristique_volume:
          productItem?.attributes?.caracrteristique_volume,
        caracrteristique_poids: productItem?.attributes?.caracrteristique_poids,
        caracrteristique_jets_aerotherapie:
          productItem?.attributes?.caracrteristique_jets_aerotherapie,
        caracrteristique_pompe_a_eau:
          productItem?.attributes?.caracrteristique_pompe_a_eau,
        caracrteristique_pompe_a_air:
          productItem?.attributes?.caracrteristique_pompe_a_air,
        caracrteristique_pompe_de_filtration:
          productItem?.attributes?.caracrteristique_pompe_de_filtration,
        caracrteristique_ordinateur_de_bord:
          productItem?.attributes?.caracrteristique_ordinateur_de_bord,
        caracrteristique_boitier_electrique_balboa:
          productItem?.attributes?.caracrteristique_boitier_electrique_balboa,
        caracrteristique_chauffage_alboa:
          productItem?.attributes?.caracrteristique_chauffage_alboa,
        caracrteristique_alimentation_electrique:
          productItem?.attributes?.caracrteristique_alimentation_electrique,
        equipement_desinfection:
          productItem?.attributes?.equipement_desinfection,
        equipement_isolation: productItem?.attributes?.equipement_isolation,
        equipement_audio: productItem?.attributes?.equipement_audio,
        equipement_haut_parleur:
          productItem?.attributes?.equipement_haut_parleur,
        equipement_wifi: productItem?.attributes?.equipement_wifi,
        equipement_capot_luxe_filtre:
          productItem?.attributes?.equipement_capot_luxe_filtre,
        equipement_niveaux_de_cale_pieds:
          productItem?.attributes?.equipement_niveaux_de_cale_pieds,
        equipement_regulateur_de_puissance:
          productItem?.attributes?.equipement_regulateur_de_puissance,
        equipement_repose_verre:
          productItem?.attributes?.equipement_repose_verre,
        equipement_acrylics_artistech:
          productItem?.attributes?.equipement_acrylics_artistech,
        equipement_biolok: productItem?.attributes?.equipement_biolok,
        equipement_filtration_cartouche:
          productItem?.attributes?.equipement_filtration_cartouche,
        equipement_filtration_bas_cons:
          productItem?.attributes?.equipement_filtration_bas_cons,
        equipement_base_abs: productItem?.attributes?.equipement_base_abs,
        equipement_aromatherapie:
          productItem?.attributes?.equipement_aromatherapie,
        equipement_cascade: productItem?.attributes?.equipement_cascade,
        equipement_easy_drain: productItem?.attributes?.equipement_easy_drain,
        equipement_bach_hivernation:
          productItem?.attributes?.equipement_bach_hivernation,
        jets_spot_de_chromotherapie:
          productItem?.attributes?.jets_spot_de_chromotherapie,
        jets_leds: productItem?.attributes?.jets_leds,
        jets_jets_retro_eclaires:
          productItem?.attributes?.jets_jets_retro_eclaires,
        jets_cascade_retro_eclairee:
          productItem?.attributes?.jets_cascade_retro_eclairee,
        jets_riviere_retro_eclairee:
          productItem?.attributes?.jets_riviere_retro_eclairee,
        jets_appui_tete_retro_eclaire:
          productItem?.attributes?.jets_appui_tete_retro_eclaire,
        jets_angles_retro_eclaires:
          productItem?.attributes?.jets_angles_retro_eclaires,
        jets_panneaux_retro_eclaires:
          productItem?.attributes?.jets_panneaux_retro_eclaires,
        jets_skimmer_retro_eclaires:
          productItem?.attributes?.jets_skimmer_retro_eclaires,
        jets_on_off_retroeclaires:
          productItem?.attributes?.jets_on_off_retroeclaires,
        jets_regulateurs_retroeclaires:
          productItem?.attributes?.jets_regulateurs_retroeclaires,
        caracrteristique_jets_hydrotherapie:
          productItem?.attributes?.caracrteristique_jets_hydrotherapie,
        caracrteristique_puissance_de_poele:
          productItem?.attributes?.caracrteristique_puissance_de_poele,
        caracrteristique_essence_de_bois:
          productItem?.attributes?.caracrteristique_essence_de_bois,
        caracrteristique_bancs: productItem?.attributes?.caracrteristique_bancs,
        caracrteristique_alimentation:
          productItem?.attributes?.caracrteristique_alimentation,
        caracrteristique_vitre: productItem?.attributes?.caracrteristique_vitre,
        caracrteristique_parois:
          productItem?.attributes?.caracrteristique_parois,
        caracrteristique_garantie:
          productItem?.attributes?.caracrteristique_garantie,
        equipement_radio: productItem?.attributes?.equipement_radio,
        equipement_blutooth: productItem?.attributes?.equipement_blutooth,
        equipement_mp3: productItem?.attributes?.equipement_mp3,
        equipement_usb: productItem?.attributes?.equipement_usb,
        equipement_haut_parleurs:
          productItem?.attributes?.equipement_haut_parleurs,
        equipement_spot_lumineux:
          productItem?.attributes?.equipement_spot_lumineux,
        equipement_dossier_retroeclaire:
          productItem?.attributes?.equipement_dossier_retroeclaire,
        equipement_couleurs_a_intensite_modulable:
          productItem?.attributes?.equipement_couleurs_a_intensite_modulable,
        equipement_aeration: productItem?.attributes?.equipement_aeration,
        sauna_acces_seau: productItem?.attributes?.sauna_acces_seau,
        sauna_acces_louche: productItem?.attributes?.sauna_acces_louche,
        sauna_acces_thermometre:
          productItem?.attributes?.sauna_acces_thermometre,
        sauna_acces_sablier_traditionnel:
          productItem?.attributes?.sauna_acces_sablier_traditionnel,
        sauna_acces_Hygrometre: productItem?.attributes?.sauna_acces_Hygrometre,
        titre1: productItem?.attributes?.titre1,
        titre2: productItem?.attributes?.titre2,
        titre3: productItem?.attributes?.titre3,
        titre5: productItem?.attributes?.titre5,
        soustitre1: productItem?.attributes?.soustitre1,
        soustitre2: productItem?.attributes?.soustitre2,
        soustitre4: productItem?.attributes?.soustitre4,
        soustitre5: productItem?.attributes?.soustitre5,
        equipement_puissance_totale:
          productItem?.attributes?.equipement_puissance_totale,
        equipement_panneaux_carbone:
          productItem?.attributes?.equipement_panneaux_carbone,
        equipement_panneau_ir: productItem?.attributes?.equipement_panneau_ir,
        equipement_tablette_tactile:
          productItem?.attributes?.equipement_tablette_tactile,
        caracrteristique_jet_de_nage:
          productItem?.attributes?.caracrteristique_jet_de_nage,
        caracrteristique_pompe_de_nage:
          productItem?.attributes?.caracrteristique_pompe_de_nage,
        showCarousel: productItem?.attributes?.showCarousel,
        order: productItem?.attributes?.order,
        menuOrder: productItem?.attributes?.menuOrder,
        promo: productItem?.attributes?.promo,
        promo_amount: productItem?.attributes?.promo_amount,
        hide: productItem?.attributes?.hide,
        price_value: productItem?.attributes?.price_value,
        relatedProducts:
          productItem?.attributes?.relatedProducts?.data?.map(
            (related) => related.id,
          ) || [],
      };

      let defaultProductEN = {
        name: englishProduct?.attributes?.name
          ? englishProduct.attributes.name.replace(/\s*\(en\)$/, "") +
            " (copy) (en)"
          : `${productItem?.attributes?.name} (copy) (en)`,

        titre4: `${englishProduct?.attributes?.titre4} (copy)`,
        type:
          englishProduct?.attributes?.type ||
          productItem?.attributes?.type ||
          0,
        collection:
          englishProduct?.attributes?.collection ||
          productItem?.attributes?.collection ||
          0,
        places:
          englishProduct?.attributes?.places ||
          productItem?.attributes?.places ||
          1,
        onstock:
          englishProduct?.attributes?.onstock ||
          productItem?.attributes?.onstock ||
          0,
        price:
          englishProduct?.attributes?.price ||
          productItem?.attributes?.price ||
          "10 000",
        ficheTechnique:
          englishProduct?.attributes?.ficheTechnique?.data?.id ||
          productItem?.attributes?.ficheTechnique?.data?.id ||
          444,
        banner: banneren.data.id,
        jetList: jetListEN?.listEN?.data?.id || null,
        pointfort: listPointFortEN?.listEN?.data?.id || null,
        colors:
          listCouleurHabillageEN?.listEN?.data?.id ||
          listCouleurHabillage.listEN.data.id,
        cuveColors:
          listCouleurCuveEN?.listEN?.data?.id || listCouleurCuve.listEN.data.id,
        pointreassurance: listPointReassuranceEN?.listEN?.data?.id || null,
        realisation: nosRealisationsEN?.listEN?.data?.id || null,
        versionImages: imagesProduitsEN?.listEN?.data?.id || null,
        image:
          englishProduct?.attributes?.image?.data?.id ||
          productItem?.attributes?.image?.data?.id ||
          defaultImage,
        image2:
          englishProduct?.attributes?.image2?.data?.id ||
          productItem?.attributes?.image2?.data?.id ||
          defaultImage,
        seo: SEOen.data.id,
        // Copy all other attributes from original product, prioritizing English values
        subtitle:
          englishProduct?.attributes?.subtitle ||
          productItem?.attributes?.subtitle,
        description:
          englishProduct?.attributes?.description ||
          productItem?.attributes?.description,
        caracrteristique_longueur:
          englishProduct?.attributes?.caracrteristique_longueur,
        caracrteristique_largeur:
          englishProduct?.attributes?.caracrteristique_largeur,
        caracrteristique_hauteur:
          englishProduct?.attributes?.caracrteristique_hauteur,
        caracrteristique_capacite:
          englishProduct?.attributes?.caracrteristique_capacite,
        caracrteristique_places_allonges:
          englishProduct?.attributes?.caracrteristique_places_allonges,
        caracrteristique_places_assise:
          englishProduct?.attributes?.caracrteristique_places_assise,
        caracrteristique_volume:
          englishProduct?.attributes?.caracrteristique_volume,
        caracrteristique_poids:
          englishProduct?.attributes?.caracrteristique_poids,
        caracrteristique_jets_aerotherapie:
          englishProduct?.attributes?.caracrteristique_jets_aerotherapie,
        caracrteristique_pompe_a_eau:
          englishProduct?.attributes?.caracrteristique_pompe_a_eau,
        caracrteristique_pompe_a_air:
          englishProduct?.attributes?.caracrteristique_pompe_a_air,
        caracrteristique_pompe_de_filtration:
          englishProduct?.attributes?.caracrteristique_pompe_de_filtration,
        caracrteristique_ordinateur_de_bord:
          englishProduct?.attributes?.caracrteristique_ordinateur_de_bord,
        caracrteristique_boitier_electrique_balboa:
          englishProduct?.attributes
            ?.caracrteristique_boitier_electrique_balboa,
        caracrteristique_chauffage_alboa:
          englishProduct?.attributes?.caracrteristique_chauffage_alboa,
        caracrteristique_alimentation_electrique:
          englishProduct?.attributes?.caracrteristique_alimentation_electrique,
        equipement_desinfection:
          englishProduct?.attributes?.equipement_desinfection,
        equipement_isolation: englishProduct?.attributes?.equipement_isolation,
        equipement_audio: englishProduct?.attributes?.equipement_audio,
        equipement_haut_parleur:
          englishProduct?.attributes?.equipement_haut_parleur,
        equipement_wifi: englishProduct?.attributes?.equipement_wifi,
        equipement_capot_luxe_filtre:
          englishProduct?.attributes?.equipement_capot_luxe_filtre,
        equipement_niveaux_de_cale_pieds:
          englishProduct?.attributes?.equipement_niveaux_de_cale_pieds,
        equipement_regulateur_de_puissance:
          englishProduct?.attributes?.equipement_regulateur_de_puissance,
        equipement_repose_verre:
          englishProduct?.attributes?.equipement_repose_verre,
        equipement_acrylics_artistech:
          englishProduct?.attributes?.equipement_acrylics_artistech,
        equipement_biolok: englishProduct?.attributes?.equipement_biolok,
        equipement_filtration_cartouche:
          englishProduct?.attributes?.equipement_filtration_cartouche,
        equipement_filtration_bas_cons:
          englishProduct?.attributes?.equipement_filtration_bas_cons,
        equipement_base_abs: englishProduct?.attributes?.equipement_base_abs,
        equipement_aromatherapie:
          englishProduct?.attributes?.equipement_aromatherapie,
        equipement_cascade: englishProduct?.attributes?.equipement_cascade,
        equipement_easy_drain:
          englishProduct?.attributes?.equipement_easy_drain,
        equipement_bach_hivernation:
          englishProduct?.attributes?.equipement_bach_hivernation,
        jets_spot_de_chromotherapie:
          englishProduct?.attributes?.jets_spot_de_chromotherapie,
        jets_leds: englishProduct?.attributes?.jets_leds,
        jets_jets_retro_eclaires:
          englishProduct?.attributes?.jets_jets_retro_eclaires,
        jets_cascade_retro_eclairee:
          englishProduct?.attributes?.jets_cascade_retro_eclairee,
        jets_riviere_retro_eclairee:
          englishProduct?.attributes?.jets_riviere_retro_eclairee,
        jets_appui_tete_retro_eclaire:
          englishProduct?.attributes?.jets_appui_tete_retro_eclaire,
        jets_angles_retro_eclaires:
          englishProduct?.attributes?.jets_angles_retro_eclaires,
        jets_panneaux_retro_eclaires:
          englishProduct?.attributes?.jets_panneaux_retro_eclaires,
        jets_skimmer_retro_eclaires:
          englishProduct?.attributes?.jets_skimmer_retro_eclaires,
        jets_on_off_retroeclaires:
          englishProduct?.attributes?.jets_on_off_retroeclaires,
        jets_regulateurs_retroeclaires:
          englishProduct?.attributes?.jets_regulateurs_retroeclaires,
        caracrteristique_jets_hydrotherapie:
          englishProduct?.attributes?.caracrteristique_jets_hydrotherapie,
        caracrteristique_puissance_de_poele:
          englishProduct?.attributes?.caracrteristique_puissance_de_poele,
        caracrteristique_essence_de_bois:
          englishProduct?.attributes?.caracrteristique_essence_de_bois,
        caracrteristique_bancs:
          englishProduct?.attributes?.caracrteristique_bancs,
        caracrteristique_alimentation:
          englishProduct?.attributes?.caracrteristique_alimentation,
        caracrteristique_vitre:
          englishProduct?.attributes?.caracrteristique_vitre,
        caracrteristique_parois:
          englishProduct?.attributes?.caracrteristique_parois,
        caracrteristique_garantie:
          englishProduct?.attributes?.caracrteristique_garantie,
        equipement_radio: englishProduct?.attributes?.equipement_radio,
        equipement_blutooth: englishProduct?.attributes?.equipement_blutooth,
        equipement_mp3: englishProduct?.attributes?.equipement_mp3,
        equipement_usb: englishProduct?.attributes?.equipement_usb,
        equipement_haut_parleurs:
          englishProduct?.attributes?.equipement_haut_parleurs,
        equipement_spot_lumineux:
          englishProduct?.attributes?.equipement_spot_lumineux,
        equipement_dossier_retroeclaire:
          englishProduct?.attributes?.equipement_dossier_retroeclaire,
        equipement_couleurs_a_intensite_modulable:
          englishProduct?.attributes?.equipement_couleurs_a_intensite_modulable,
        equipement_aeration: englishProduct?.attributes?.equipement_aeration,
        sauna_acces_seau: englishProduct?.attributes?.sauna_acces_seau,
        sauna_acces_louche: englishProduct?.attributes?.sauna_acces_louche,
        sauna_acces_thermometre:
          englishProduct?.attributes?.sauna_acces_thermometre,
        sauna_acces_sablier_traditionnel:
          englishProduct?.attributes?.sauna_acces_sablier_traditionnel,
        sauna_acces_Hygrometre:
          englishProduct?.attributes?.sauna_acces_Hygrometre,
        titre1: englishProduct?.attributes?.titre1,
        titre2: englishProduct?.attributes?.titre2,
        titre3: englishProduct?.attributes?.titre3,
        titre5: englishProduct?.attributes?.titre5,
        soustitre1: englishProduct?.attributes?.soustitre1,
        soustitre2: englishProduct?.attributes?.soustitre2,
        soustitre3: englishProduct?.attributes?.soustitre3,
        soustitre4: englishProduct?.attributes?.soustitre4,
        soustitre5: englishProduct?.attributes?.soustitre5,
        equipement_puissance_totale:
          englishProduct?.attributes?.equipement_puissance_totale,
        equipement_panneaux_carbone:
          englishProduct?.attributes?.equipement_panneaux_carbone,
        equipement_panneau_ir:
          englishProduct?.attributes?.equipement_panneau_ir,
        equipement_tablette_tactile:
          englishProduct?.attributes?.equipement_tablette_tactile,
        caracrteristique_jet_de_nage:
          englishProduct?.attributes?.caracrteristique_jet_de_nage,
        caracrteristique_pompe_de_nage:
          englishProduct?.attributes?.caracrteristique_pompe_de_nage,
        showCarousel: englishProduct?.attributes?.showCarousel,
        order: englishProduct?.attributes?.order,
        menuOrder: englishProduct?.attributes?.menuOrder,
        promo: englishProduct?.attributes?.promo,
        promo_amount: englishProduct?.attributes?.promo_amount,
        hide: englishProduct?.attributes?.hide,
        price_value: englishProduct?.attributes?.price_value,
        relatedProducts:
          englishProduct?.attributes?.relatedProducts?.data?.map(
            (related) => related.id,
          ) || [],
      };
      // Create the duplicated products with i18n attachment
      const productFr = await API.post("/api/products", {
        data: defaultProductFr,
        params: { locale: "fr" },
      });
      const productEn = await API.post(
        `/api/products/${productFr.data.data.id}/localizations`,
        {
          locale: "en",
          ...defaultProductEN,
        },
      );

      await API.put(`/api/products/${productFr.data.data.id}`, {
        data: {
          path: productUrlRewrite(
            productFr.data.data.id,
            productFr.data.data.attributes.name,
          ),
        },
      });
      await API.put(`/api/products/${productEn.data.id}`, {
        data: {
          path: productUrlRewrite(productEn.data.id, productEn.data.name),
        },
      });

      dispatch(
        handleInfo(
          "Produit dupliqué avec succès, vous pouvez le modifier... ",
          1,
        ),
      );
      dispatch(getAllProducts());
    }
  } catch (error) {
    dispatch(handleError("erreur réseau", 1));
    console.log(error);
  }
};
